import Table from "react-bootstrap/esm/Table";

import { formatCurrency } from "../../../helper-functions";
import { AccumulatorWithDate } from "../../../models/Accumulator";
import { PlanAllotment } from "../../../models/PlanAllotment";
import { ProductUsageBar } from "./ProductUsageBar";
import { VisionProductWarning } from "./VisionProductWarning";
import { getPercentUtilized, getRemainder, isDollarAmount } from "./utils";

export type AccumulatorProduct = {
    name: string;
    allotment?: PlanAllotment;
    accumulator?: AccumulatorWithDate;
    defaultAllotment?: number;
    showWarning?: boolean;
};

const AccumulatorProductRow = ({ product }: { product: AccumulatorProduct }) => {
    const { name, allotment, accumulator, showWarning } = product;

    const defaultAllotment = product.defaultAllotment ?? 0;

    const isDollarAmt = isDollarAmount(allotment?.accumulationType) || isDollarAmount(accumulator?.accumulationType);

    const benefitValue = allotment?.benefitValue ?? (isDollarAmt ? 0 : defaultAllotment);

    const utilized = accumulator?.accumulatorAmt ?? 0;

    const percentUtilized = getPercentUtilized(benefitValue, utilized);

    const remainder = getRemainder(benefitValue, utilized);

    return (
        <>
            <tr>
                <td></td>
                <td>{name}</td>
                {showWarning ? (
                    <td colSpan={5}>
                        <VisionProductWarning />
                    </td>
                ) : (
                    <>
                        <td>{isDollarAmt ? formatCurrency(benefitValue) : benefitValue}</td>
                        <td>{isDollarAmt ? formatCurrency(utilized) : utilized}</td>
                        <td>{isDollarAmt ? formatCurrency(remainder) : remainder}</td>
                        <td width="15%">
                            <ProductUsageBar percentUtilized={percentUtilized} />
                        </td>
                        <td>{percentUtilized}%</td>
                    </>
                )}
                <td>
                    {accumulator?.lastServiceDate ? new Date(accumulator.lastServiceDate).toLocaleDateString() : "-"}
                </td>
            </tr>
        </>
    );
};

export const AccumulatorProductTable = ({
    type,
    products,
    dependentSequenceNumber,
}: {
    type: "dental" | "vision";
    products: AccumulatorProduct[];
    dependentSequenceNumber?: number;
}) => {
    return (
        <Table>
            <thead>
                <tr>
                    <th></th>
                    {type === "dental" ? <th>Dental Product</th> : <th>Vision Product</th>}
                    <th>Allotment</th>
                    <th>Utilized</th>
                    <th>Remaining</th>
                    <th></th>
                    <th></th>
                    <th>Last Service Date</th>
                </tr>
            </thead>
            <tbody>
                {products.map((product) => (
                    <AccumulatorProductRow
                        key={`${type}-${product.name}-${dependentSequenceNumber}`}
                        product={product}
                    />
                ))}
            </tbody>
        </Table>
    );
};
